"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        chips: {
            marginRight: theme.spacing(0.5),
        },
        label: {
            fontWeight: 500,
        },
        container: {
            padding: "".concat(theme.spacing(2), " 0"),
        },
    });
});
